import React, { useContext, useState, useEffect } from 'react'
import MaterialTable from 'material-table'
import tableIcons, { options } from "components/universal/table_attributes";
import TableAction from "actions/table_actions";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Box, IconButton, Paper, Popover, Typography, Grid, withStyles } from "@material-ui/core";
import MROButton from 'components/buttons';
import moment from 'moment';
import ShiftServices from 'lib/services/api/planning/Shifts/shift';
import { ToastMessageContext } from 'lib/contexts/message_context';
import { getOrganisationId } from 'lib/utils/common_utils';
import GreenTickIcon from 'assets/green_filled_tick.png'
import RedCrossIcon from 'assets/Red remove icon.png'
import GearAmbear from 'assets/Amber gear@3x.png'
import { Delete } from '@material-ui/icons';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import CreateLeaveRequest from 'views/Planning/Shifts/Leave/NewLeaveRequest';
import LinearProgress from '@material-ui/core/LinearProgress';
import LeavePopUp from './LeavePopUp';


const BorderLinearProgress = withStyles((theme) => ({
    root: {
        height: 23,
        borderRadius: 10,
    },
    colorPrimary: {
        backgroundColor: '#4FC605',
    },
    bar: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
    },
}))(LinearProgress);

export default function MyLeave() {
    const [page, setPage] = useState(0)
    const [pageSize, setPageSize] = useState(10)
    const [totalCount, setTotalCount] = useState(10)
    const [action, setAction] = useState('')
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const message = useContext(ToastMessageContext)
    let userDetails = JSON.parse(sessionStorage.getItem("user"));
    const [sectionDetails, setSectionDetails] = useState({})
    const [mouseX, setMouseX] = useState();
    const [mouseY, setMouseY] = useState();
    const [poperState, setPoperState] = useState(false)
    const [currentCommentsSelections, setCurrentCommentSelections] = useState({});
    const [gaugeValue, setGaugeValue] = useState(0)

    const getListing = () => {

        const params = {
            organisation_id: getOrganisationId(),
            page: page + 1,
            limit: pageSize,
            user_id: userDetails?.id,
            app: true

        }

        setLoading(true)
        ShiftServices.getShiftLeaveDetails(params).then((res) => {
            setData(res.data)
            setTotalCount(res.total_count)
        }).catch(() => {
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }).finally(() => {
            setLoading(false)
        })

    }


    const handlepopupclose = () => {
        setAction("")
        setPoperState(false)
    }

    useEffect(() => {

        getListing();

    }, [page, pageSize, totalCount]);



    const getSectionDetails = () => {

        const params = {
            organisation_id: getOrganisationId(),
            user_id: userDetails?.id,
        }


        ShiftServices.getHomePageMyLeaveSectionDetails(params).then((res) => {
            setSectionDetails(res.data)
            let value = parseFloat(res?.data?.request_total)
            let remaining = parseFloat(res?.data?.this_period_remaining).toFixed(2)

            if (value > remaining && remaining !== 0) {
                let tot = value - remaining
                let percentage = parseFloat(50 + tot).toFixed(2)
                // console.log(tot)
                setGaugeValue(isNaN(value) ? 0 : percentage > 100 && remaining !== 0 ? 80 : percentage)
            }
            else if (remaining > value) {
                let tot = remaining - value
                let total = tot > 100 ? remaining - tot : remaining - value

                let percentage = parseFloat(total <= 10 ? 5 : total <= 20 ? 10 : total <= 30 ? 15 : total <= 40 ? 20 : total <= 50 ? 25 : total <= 60 ? 30 : total <= 70 ? 35 : total <= 80 ? 40 : total <= 90 ? 45 : total <= 100 ? 50 : 50 - tot).toFixed(2)
                // console.log(tot)
                setGaugeValue(isNaN(value) ? 0 : percentage)
            }
            else if (remaining === 0 && value === 0) {
                setGaugeValue(0)
            }
            else if (remaining === value && remaining !== 0 && value !== 0) {
                setGaugeValue(50)
            }
            else if (remaining === 0 && value > 0) {

                setGaugeValue(100)
            }
            else {

                setGaugeValue(isNaN(value) ? 0 : value)
            }

        }).catch(() => {
            message.showToastMessage({
                message: "Something went wrong. Try again!",
                variant: "error",
            });
        }).finally(() => {

        })




    }
    console.log("Value=====", gaugeValue)
    useEffect(() => {
        getSectionDetails()
    }, [])




    const tableOptions = {
        ...options,
        page: page,
        total: totalCount,
        pageSize: pageSize,
        search: false,
        toolbar: false
    };
    const handleDelete = async (rowData) => {

        setLoading(true)
        await ShiftServices.deleteLeaveRequest(rowData.id).then((res) => {

            message.showToastMessage({
                message: "Leave request deleted successfully !",
                variant: "success",
            });

            getListing()
        }).catch((res) => {

            message.showToastMessage({
                message: res.message ? res.message : "Something went wrong. Try again!",
                variant: "error",
            });
        }).finally(() => {
            setLoading(false)
        })
    }

    const columns = [


        {
            title: "Requested",
            field: "requested",
            width: '30%',
            headerStyle: {
                textAlign: 'left',
                paddingLeft: '20px',

                width: '30%',

            },
            cellStyle: {
                textAlign: 'left',
                paddingLeft: '20px',
                width: '30%',
            }
        },
        {
            title: "Leave Start",
            field: "leave_start",
            width: '10%'
        },
        {
            title: "Leave End",
            field: "leave_end",
            width: '10%'
        },
        {
            title: "Days",
            field: "days",
        }, {
            title: "Shifts",
            field: "shifts",
        }, {
            title: "Hours",
            field: "hours",
        },
        {
            title: "Status",
            field: "status",
            render: (rowData) => <div>
                {rowData?.status === 1 ? <img src={GreenTickIcon} height={'18px'} /> : rowData?.status === 2 ? <img src={RedCrossIcon} height={'18px'} style={{ cursor: 'pointer' }} onClick={(e) => {
                    setAction("view_key");
                    setCurrentCommentSelections(rowData);
                    setPoperState(!poperState)
                    setMouseX(e.clientX);
                    setMouseY(e.clientY);
                }} /> : rowData?.status === 0 || rowData?.status === 3 ? <img src={GearAmbear} height={'18px'} /> : "  "}

                {action === "view_key" && <Popover id='key' open={Boolean(poperState)}
                    anchorReference={'anchorPosition'}
                    onClose={handlepopupclose}
                    anchorEl={poperState}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    anchorPosition={{ top: mouseY, left: mouseX }}
                    PaperProps={{
                        marginLeft: '-11px'
                    }}
                >

                    <Paper style={{ width: 'max-content', height: 'fit-content', padding: '10px' }}>
                        <Typography style={{ fontSize: '13px' }}>{currentCommentsSelections?.reject_reason
                        }</Typography>


                    </Paper>
                </Popover>}
            </div>
        }, {
            title: "Action",
            field: "",
            render: (rowData) => (
                rowData?.status === 0 || rowData?.status === 3 ? <IconButton onClick={() => {
                    handleDelete(rowData)
                }}>

                    <Delete htmlColor={ICON_COLOUR} fontSize='small' />
                </IconButton> : ''
            )

        },

    ];
    // console.log("gaugevalue=", isNaN(gaugeValue))


    return (
        <div>

            <Grid container xs={12} style={{ justifyContent: 'end' }}>
                <Grid xs={2} style={{ paddingTop: '7px', cursor: 'pointer' }} >  <BorderLinearProgress variant="determinate" value={gaugeValue || 0} maxValue={300} onClick={() => {
                    // setGauge(true)
                    setAction("popup")
                }}


                // onMouseOut={() => {
                //     setGauge(false)
                //     setAction('')
                // }}
                /></Grid>
                <Grid ></Grid>
                <Grid xs={1} style={{ paddingTop: '7px', textAlign: 'center' }} ><Typography><span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
                    // setGauge(true)
                    setAction("popup")
                }}>{sectionDetails?.request_total ? sectionDetails?.request_total : 0}</span>/<span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={() => {
                    // setGauge(true)
                    setAction("popup")
                }}>{sectionDetails?.this_period_remaining}</span> </Typography></Grid>
                <Grid>
                    <MROButton color='secondary' variant='contained' onClick={() => { setAction('create') }}>+ Add Request</MROButton></Grid>



            </Grid>







            <div style={{ marginTop: '20px' }}>




                <MaterialTable
                    style={{ boxShadow: "0px 1px 3px #00000033", paddingRight: "0px" }}
                    icons={tableIcons}
                    classes
                    title={""}
                    columns={columns}
                    data={data || []}
                    isLoading={loading}
                    options={tableOptions}
                    localization={{
                        toolbar: {
                            searchPlaceholder: "Search anything",
                        },
                        body: {
                            emptyDataSourceMessage: "No Records found",

                        },

                    }}
                    onChangePage={(page) => {
                        setPage(page);
                    }}
                    onChangeRowsPerPage={(pageSize) => {
                        setPageSize(pageSize);
                    }}
                    totalCount={totalCount}
                    page={page}
                />

            </div>
            {action && action === "create" && <CreateLeaveRequest handleClose={() => {
                setAction('')
            }} getListing={getListing} type={"home"} />}

            {action && action === "popup" && <LeavePopUp handleClose={() => {
                setAction('')
            }} getListing={getListing} currentSelection={sectionDetails} />}
        </div>
    )
}
